import React from "react"
import types from "prop-types"
import { BackfillReportableFieldContextProvider } from "contexts/BackfillReportableFieldContext"
import { categoryOptionShape } from "utils/propTypeShapes"
import BackfillReportableFieldForm from "./BackfillReportableFieldForm"

const BackfillReportableField = ({ categories, organizationSubdomain }) => (
  <BackfillReportableFieldContextProvider organizationSubdomain={organizationSubdomain} categories={categories}>
    <BackfillReportableFieldForm />
  </BackfillReportableFieldContextProvider>
)

BackfillReportableField.propTypes = {
  categories: types.arrayOf(categoryOptionShape).isRequired,
  organizationSubdomain: types.string.isRequired,
}

export default BackfillReportableField
